import { AlertSupportImpl } from "../data/AlertSupportImpl";
import { IAlertSupportRepository } from "../domain/repositories/IAlertSupportRepository";
import { AlertSupportUseCase } from "../domain/useCases/AlertSupportUseCase";
import { VnskySupportAlertViewModel } from "../presentation/viewModel/VnskySupportAlertViewModel";
import { InjectionBinding, InjectionModule } from "app/di/DependencyInjections";

export class VnskySupportAlertInjection extends InjectionModule {
  private static readonly vnskySupportAlertViewModelToken = Symbol(
    "VnskySupportAlertViewModel",
  );
  private static readonly alertSupportRepositoryToken = Symbol(
    "IAlertSupportRepository",
  );
  private static readonly alertSupportUseCaseToken = Symbol(
    "AlertSupportUseCase",
  );

  protected static override bindings: InjectionBinding[] = [
    {
      scope: "otherRepo",
      token: this.alertSupportRepositoryToken,
      useClass: AlertSupportImpl,
    },
    {
      scope: "otherRepo",
      token: this.alertSupportUseCaseToken,
      useClass: AlertSupportUseCase,
    },
    {
      scope: "viewModel",
      token: this.vnskySupportAlertViewModelToken,
      useClass: VnskySupportAlertViewModel,
    },
  ];

  static getRepo(): IAlertSupportRepository {
    return this.resolve(this.alertSupportRepositoryToken);
  }

  static getUseCase(): AlertSupportUseCase {
    return this.resolve(this.alertSupportUseCaseToken);
  }
}
